export default __webpack_public_path__ + "static/media/en-logo.1f9c6eab.svg";